function Ctrl($scope, $state, $timeout, authService, utilsService) {
  $scope.loginFbSubmitting = null;
  $scope.loginFbResult = null;
  $scope.loginFbBtnOptions = {
    buttonDefaultText: 'Sign up with Facebook',
    buttonSubmittingText: 'Logging in...',
    buttonSuccessText: 'Login successful',
    buttonErrorText: 'Error logging in',
    buttonDefaultIcon: 'fa fa-facebook-square',
    buttonSubmittingIcon: 'icon-left fa fa-spin fa-refresh',
    buttonSuccessIcon: 'icon-left fa fa-check',
    buttonErrorIcon: 'icon-left fa fa-remove',
    buttonDefaultClass: 'btn-facebook',
    buttonSuccessClass: 'btn-success',
    buttonErrorClass: 'btn-danger'
  };

  $scope.facebook = function() {
    $scope.loginFbSubmitting = true;

    authService.loginWithFacebook(success, error);
  };

  const success = function(response) {
    $scope.loginFbSubmitting = false;

    $scope.config.facebookLogin = true;

    $timeout(function() {
      $scope.loginFbResult = 'success';
      $scope.callback(response);
    }, 100);
  };

  const error = function(response) {
    $scope.loginFbResult = 'error';
    $scope.facebookError = utilsService.errorMessage(response);
    $scope.callback(response, $scope.facebookError);
  };
}

Ctrl.$inject = [
  '$scope',
  '$state',
  '$timeout',
  'tl.auth.service',
  'utilsService'
];

export default Ctrl;



// WEBPACK FOOTER //
// ./src/directives/loginFacebook/controller.js